<template>
	<div class="byline">
		<div class="byline__text" v-html="contexte.signature">
		</div>
		<a :href="contexte.urls.homepage" target="_blank" class="byline__image">
			<img :src="contexte.logo" alt="Logo de Contexte" />
		</a>
	</div>	
</template>
<script>
	import contexteLogo from "../assets/logo_contexte.svg"
	const contexteHomepageUrl = 'https://www.contexte.com'

	export default {
		name: 'Byline',
		data: function() {
			return {
				contexte: {
					logo: contexteLogo,
					urls: {
						homepage: contexteHomepageUrl,
					},
					signature: 'Infographie créée<br> par le journal'
				},
			}
		},
		created() {
			if (600 < window.innerWidth && window.innerWidth < 800) this.contexte.signature = 'Créé par<br> le journal'
			if (window.innerWidth <= 600) this.contexte.signature = 'Infographie créée par le journal'
		}
	}
</script>
<style lang="scss">
	$bylineGrey: #666;
	.byline {
		top: 5px;
		right: 0;
		position: absolute;
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-end;
		align-items: center;
		> * {
			margin: 0 8px;
		}
		&__text {
			text-transform: uppercase;
			color: $bylineGrey;
			font-size: .8em;
			margin-top: 5px;
			text-align: right
		}
		&__image {
			flex: 0 0 130px;
			display: block;
			img {
				width: 100%;
			}
		}
	}
	/*
	@media screen and (max-width: 800px)  {
		.byline {
			top: -5px;
			
			&__text {
				font-size: .8em;
			}
			&__image {
				margin-left: auto;
				width: 110px;
			}
		}
	}
	*/
	@media screen and (max-width: 600px)  {
		.byline { 
			display: block;
			position: relative;
			top: unset;
			right: unset;
			margin-bottom: 1.4em;
			&__text {
				text-align: center;
				margin: 0 auto;
			}
			&__image {
				margin: 0 auto;
				width: 130px;
			}
		}
	}
</style>